import { getHttpClient } from './httpClient';

export type PilotApplicationStatus = 'pending' | 'accepted' | 'rejected' | 'waitlist';
export type PilotIndustry = 'industry' | 'services' | 'it' | 'health' | 'logistics' | 'other';
export type PilotTeamSize = '5-15' | '16-50' | '50+';

export interface PilotApplication {
  id: string;
  full_name: string;
  email: string;
  phone: string;
  company: string;
  role: string;
  industry: PilotIndustry;
  team_size: PilotTeamSize;
  motivation: string;
  locale: string;
  status: PilotApplicationStatus;
  ip_address: string | null;
  user_agent: string | null;
  created_at: string;
  updated_at: string;
}

export interface StatusCounts {
  total: number;
  pending: number;
  accepted: number;
  rejected: number;
  waitlist: number;
}

export async function listApplications(
  status?: PilotApplicationStatus,
): Promise<{ applications: PilotApplication[] }> {
  const params = status ? { status } : {};
  const { data } = await getHttpClient().get('/api/admin/pilot-applications', { params });
  return data;
}

export async function getCounts(): Promise<StatusCounts> {
  const { data } = await getHttpClient().get('/api/admin/pilot-applications/counts');
  return data;
}

export async function getApplication(id: string): Promise<PilotApplication> {
  const { data } = await getHttpClient().get(`/api/admin/pilot-applications/${id}`);
  return data;
}

export async function updateStatus(
  id: string,
  status: PilotApplicationStatus,
): Promise<PilotApplication> {
  const { data } = await getHttpClient().patch(
    `/api/admin/pilot-applications/${id}/status`,
    { status },
  );
  return data;
}
